import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getWoundMeasurements } from "../../../../../app/patientSlice";

export const useMeasurementFetch = ({ assessmentId, patientId, measurementData }) => {
  const dispatch = useDispatch();
  const [pendingRetires, setPendingRetires] = useState(0);
  const [pendingTimer, setPendingTimer] = useState(15000);

  const fetchMeasurements = useCallback(() => {
    const payload = {
      assessmentid: assessmentId,
      patientId,
    };
    dispatch(getWoundMeasurements(payload));
  }, [assessmentId, patientId, dispatch]);

  useEffect(() => {
    fetchMeasurements();
  }, [fetchMeasurements]);

  useEffect(() => {
    let timer = null;
    if (measurementData?.status === "pending" && !measurementData?.measurementRetry) {
      timer = setTimeout(() => {
        setPendingRetires((prev) => prev + 1);
        fetchMeasurements();
      }, pendingTimer);
    }
    return () => clearTimeout(timer);
  }, [fetchMeasurements, measurementData?.measurementRetry, measurementData?.status, pendingTimer]);

  return { pendingRetires, setPendingRetires, pendingTimer, setPendingTimer };
};
